const API_TAGS = {
  TRACK_N_TRACE: 'TrackAndTrace',
};

export default API_TAGS;
